import gql from "graphql-tag";
const getOraclesQuery = gql(` 
query GetOracle($params: AWSJSON!) {
  getOracle(params: $params) {
    id
    result
    profile
    nearest
  }
}
`)
export default getOraclesQuery;